import {
    GET_RType,
    ADD_RType,
    TOGGLE_RType,
    RESET_RType,
    UPDATE_RType
  } from "../actionTypes";

const relationshipTypeReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_RType:
      return action.payload;

    case ADD_RType:
      return action.payload;

    case UPDATE_RType:
      return state.map(item =>
        item.id === action.payload.id ? action.payload : item
      );

    case TOGGLE_RType:
      return {
        ...state,
        users: state.users.map(item =>
          item.userId === action.payload.userId ? action.payload : item
        )
      };

    case RESET_RType:
      return null;

    default:
      return state;
  }
};

export default relationshipTypeReducer;
